import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { sportApi } from '../../api';
import { ISportStore } from './store.types';

export const useSportStore = create<ISportStore>()(immer((set) => ({
  list: [],
  async fetchSports() {
    const result = await sportApi.getSports({});
    set({ list: result.items });
    return result.items;
  },
})));
